import type { ReactNode } from 'react';

export function SampleLabel({
  children,
  className = '',
}: {
  children: ReactNode;
  className?: string;
}) {
  return <span className={`sample-label ${className}`.trim()}>{children}</span>;
}
